import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import type { UturnFileDTO } from '@uturn/api/v1';
import { useGetAllDocumentsSuspense } from '@uturn/api/v1';
import { useDeleteDocumentById } from '@uturn/api/v2';
import { queryClient } from '@uturn/portal/query';

import {
	Button,
	Card,
	CardDescription,
	CardHeader,
	CardTitle,
	Icon,
	sonner,
} from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

export default function OrganizationDocuments() {
	const { t } = useTranslation();

	const { data: documents, queryKey } = useGetAllDocumentsSuspense({
		query: {
			select: (data) => data.data,
		},
	});

	const { mutate: deleteDocument } = useDeleteDocumentById();

	const handleDelete = (documentId: string) => {
		deleteDocument(
			{
				documentId,
			},
			{
				onSuccess: () => {
					sonner.success(
						t(
							'pages.account.organisation.documents.submit.success.description',
							'The document has been deleted',
						),
					);
					queryClient.invalidateQueries({ queryKey });
				},
				onError: () => {
					sonner.error(
						t(
							'pages.account.organisation.documents.submit.error.description',
							'Failed to delete the document',
						),
					);
				},
			},
		);
	};

	return documents.map((document) => (
		<Card key={document.uuid}>
			<CardHeader className="relative">
				<CardTitle>{document.fileTypeDescription}</CardTitle>
				<CardDescription>{document.description}</CardDescription>
				<div className="absolute right-6">
					<Button
						variant="ghost"
						onClick={() =>
							!document.uuid
								? sonner.error(
										t(
											'pages.account.organisation.documents.document.id.missing',
											'Document ID not found',
										),
									)
								: handleDelete(document.uuid)
						}
					>
						<Icon icon={faTrashCan} className="size-4" />
					</Button>
				</div>
			</CardHeader>
		</Card>
	));
}
